import CONSTANTS from '../constants'
import { getRequest } from '../../services'
import { APICONFIG } from '../config/apiConfig'
import { getConfigDetails } from '../../services/config'
import { addEventLog } from '../../pages/warningCitation/redux/actions/EventsLog'

// Calls the API to get Facility Initials
export const getPermitRequestList = () => (dispatch) => {
    dispatch(addEventLog('', CONSTANTS.GET_PERMIT_REQUEST_LIST_REQUEST))
    dispatch({ type: CONSTANTS.GET_PERMIT_REQUEST_LIST_REQUEST })
    return getRequest(`${APICONFIG.getPermitRequestUrl}?partner_id=${getConfigDetails()?.PARTNER_ID}`).then((res) => {
        // return getRequest(`${APICONFIG.getPermitRequestUrl}?partner_id=${getConfigDetails()?.PARTNER_ID}`).then((res) => {
        let resObject = res 
        dispatch(addEventLog(resObject, CONSTANTS.GET_PERMIT_REQUEST_LIST_SUCCESS))
        dispatch({ type: CONSTANTS.GET_PERMIT_REQUEST_LIST_SUCCESS, data: res.data })
        return res.data
    }).catch((err) => {
        let errObject = err 
        dispatch(addEventLog(errObject, CONSTANTS.GET_PERMIT_REQUEST_LIST_FAILURE))
        dispatch({ type: CONSTANTS.GET_PERMIT_REQUEST_LIST_FAILURE })
        return err
    })
}
